<template>
  <PageWrapper
    v-if="canEditStories"
    :active-page="PAGE_STORY_EDITOR"
    :active-section="SECTION_STORIES"
    hide-sidebar
    :style-overrides="{
      contentPaddingBottom: 'none'
    }"
  >
    <StoryEditorComponent />
  </PageWrapper>
  <iText v-else>
    You don't have access to view this page.
  </iText>
</template>

<script>
import { PAGE_STORY_EDITOR, SECTION_STORIES } from "@/constants/nav-constants";
import PageWrapper from "@/components/PageWrapper.vue";
import StoryEditorComponent from "@/components/publication/StoryEditorComponent";
import { useCollaboratorStore } from "~/stores/collaborator-store";
import { mapState } from "pinia";

export default {
  name: "StoryEditor",
  components: {
    StoryEditorComponent,
    PageWrapper,
  },
  data() {
    return {
      PAGE_STORY_EDITOR,
      SECTION_STORIES,
    };
  },
  computed: {
    ...mapState(useCollaboratorStore, [
      "canEditStories",
    ]),
  },
};
</script>

<style lang="scss" scoped>
</style>
